var d3 = {
  ...require("d3-axis/dist/d3-axis.min"),
  ...require("d3-scale/dist/d3-scale.min"),
  ...require("d3-selection/dist/d3-selection.min"),
  ...require("d3-shape/dist/d3-shape.min")
};


var caret = `<button class="toggleIcon" href = "#void" title='Toggle Definition'>
				<span class="inner">
					<svg viewBox="0 0 16 16">
						<path d="M8 12.043l7.413-8.087H.587z"></path>
					</svg>
				</span>
			</button>`

//add span with definition
d3.selectAll("span.definition")
	.html(function(d){
		var definitionText = `<span class="definitionText hidden" > 
							<p> ${d3.select(this).attr("definition")} </p> </span>`;
		var current = `<span style="text-decoration: underline;"> ${d3.select(this).html()}</span>`;
		return current + caret + definitionText;
	});

d3.selectAll(".toggleIcon")
		.on("click",function(d){
			var definitionText = d3.select(this.closest(".definition")).select(".definitionText");
			definitionText.classed("hidden", definitionText.classed("hidden") ? false : true);
			
		});

d3.selectAll(".toggleIcon")
.on("keydown",function(e){
	var key = e.which;
	if (key == 13){
		e.preventDefault();
		this.click();
	}
});
